export const fr = {
  clipboard: {
    successCopied: "Copié dans le presse‑papiers",
  },
  notification: {
    title: "Paramètres de notification",
    emailNotifications: "Notifications par e‑mail",
    marketingEmails: "E‑mails marketing"
  },
  safety: {
    title: "Vérification KYC",
    subtitle: "Complétez la vérification pour accéder à toutes les fonctionnalités de la plateforme.",
    bannerTitle: "Vérification via Reown",
    bannerText1: "Votre compte utilise l’authentification Reown.",
    bannerText2: "Pour améliorer votre niveau de vérification, allez dans la section « Vérification ».",
    standardLevel: "Niveau Standard",
    standardDesc: "Confirmation de l’e‑mail et du numéro de téléphone.",
    enhancedLevel: "Niveau Avancé",
    enhancedDesc: "Soumission des données du passeport.",
    professionalLevel: "Niveau Professionnel",
    professionalDesc: "Justificatif de domicile.",
    completed: "Terminé",
    inProgress: "En cours",
    start: "Commencer"
  },
  referral: {
    title: "Programme de parrainage",
    description: "Invitez des amis et gagnez des récompenses !",
    subtitle: "Votre lien de parrainage",
    yourReferrals: "Vos filleuls",
    statsElements: ["Parrains totaux", "Actifs", "Investissements totaux", "Vos gains"],
    yourLevel: {
      topTitle: "Votre niveau",
      toNextLevel: "Niveau suivant :",
      activeReferralsOr: "filleuls actifs OU",
      toLvl: "jusqu’à"
    },
    referrer: {
      title: "Vous avez un code de parrainage ? Entrez‑le ici",
      enterCode: "Entrer le code",
      check: "Vérifier"
    },
    confirm: "Confirmer",
    changeRefCode: "Modifier le code de parrainage",
    newCode: "nouveau code",
    enterNewCode: "Entrez votre nouveau code",
    minMaxChars: "Minimum 6 caractères, maximum 8"
  },
  referralNew: {
    code: {
      title: "Vous avez un code de parrainage ?",
      description: "Entrez-le ci-dessous pour vous connecter\nà votre parrain.",
      input: "Code de parrainage",
      button: "Vérifier",
      title_CodeVerified: "Code vérifié",
      description_CodeVerified: "Vous pouvez maintenant inviter d'autres personnes et gagner des récompenses.",
      youInviter: "votre parrain"
    },
    details: {
      title: "Vos détails de parrainage",
      description: "Invitez vos amis sur Zenex et gagnez des bonus.",
      sendThis: "Envoyez ce lien à votre ami",
      orShare: "Ou partagez votre code manuel",
      members: "membres",
      paidOut: "versé en 2025",
      alreadyEarning: "gagnent déjà avec nous"
    },
    program: {
      button: "En savoir plus",
      cards: {
        title: "Niveaux mensuels",
        subtitle: "Programme partenaire",
        description: "Gagnez sur le volume de cartes de vos filleuls",
        how: "Comment ça marche",
        elements: [
          "Volume total des recharges  de tous les filleuls par  mois civil",
          "Le statut est recalculé le 1er  de chaque mois",
          "La commission est versée  en fonction de votre niveau actuel"
        ]
      },
      invest: {
        title: "Système cumulatif",
        subtitle: "Programme de parrainage",
        description: "Gagnez grâce aux investissements de vos amis",
        how: "Comment gagner",
        elements: [
          "Invitez un ami à rejoindre  Zenex Invest",
          "Il commence à investir dans  les Zenex Pools",
          "Vous recevez des récompenses  sur ses gains"
        ]
      }
    }
  },
  innerReferral: {
    title: "Programme de parrainage \n Zenex Invest",
    statistic: {
      pattern: " ce mois-ci",
      status: {
        title: "Statut actuel",
        subtitle: "Vos bonus: ",
        description: "{depositBonus} du dépôt et {incomeBonus} du profit",
        labelLeft: "Jusqu’au niveau {level}",
        labelCenter: "{count, plural, one {# filleul} other {# filleuls}} ou",
        labelRight: ""
      },
      referrals: {
        title: "Parrainages actifs",
        description: "+{count} nouveaux",
      },
      deposit: {
        title: "Montant total des dépôts",
        description: "+{count}$"
      },
      income: {
        title: "Mon revenu",
        description: "~{count}$",
        pattern: "/par mois",
      },
    },
    link: {
      title: "Augmentez votre niveau et gagnez plus",
      sendThis: "Envoyez ce lien à un ami",
      orShare: "Ou partagez le code pour une saisie manuelle",
    },
    tabs: {
      levels: "Système de niveaux",
      history: "Historique des paiements",
      referrals: "Liste des filleuls",
    },
    faq: {
      kicker: "FAQ",
      title: "Comment fonctionne le système de parrainage",
      questions: [
        "Où sont créditées mes récompenses de parrainage et comment puis-je les retirer ?",
        "Le lien de parrainage est-il différent pour chaque produit ou unique ?",
        "J’ai invité un ami qui a investi dans le pool RevShare. Quand recevrai-je ma récompense ?",
        "Comment puis-je augmenter mon niveau dans le programme de parrainage ?",
      ],
      answers: [
        "Vos récompenses sont créditées directement sur le portefeuille lié à votre compte Zenex Hub, et vous pouvez les retirer vers n’importe quel portefeuille crypto externe.",
        "Un lien unique est utilisé pour tous les produits Zenex. En partageant un seul lien, vous recevez des récompenses pour chaque produit utilisé par votre filleul.",
        "Les récompenses sont créditées à partir du mois suivant. Vous recevez une partie de leur dépôt (récompense unique) et une partie de leur profit (récompenses mensuelles récurrentes).",
        "Votre niveau augmente dès que le volume total d’investissement de vos filleuls atteint le seuil requis. Le nouveau niveau s’applique au début du mois suivant.",
      ],
    },
    levels: {
      title: "Système de niveaux et de récompenses",
      description: "Le niveau est déterminé par le meilleur indicateur : nombre de filleuls actifs ou montant total de leurs investissements",
      status: {
        received: "Reçu",
        current: "Niveau actuel",
        blocked: "Bloqué",
        more: "Encore {count, plural, one {# filleul} other {# filleuls}}",
      },
      level: {
        associate: "Associate",
        partner: "Partner",
        executive: "Executive",
        elite: "Elite",
        ambassador: "Ambassador",
      },
      rows: {
        referrals: "Filleuls",
        total: "Montant total des dépôts",
        incomeDeposit: "Revenu du dépôt",
        incomeStable: "Revenu du Stable Pool",
        incomeGrowth: "Revenu du Growth Pool",
      },
    },
    filters: {
      label: "Trier par",
      dateAscending: "Date : croissante",
      dateDescending: "Date : décroissante",
      incomeAscending: "Revenu : croissant",
      incomeDescending: "Revenu : décroissant",
    },
    pagination: "Page {current} sur {total}",
    incomeHistory: {
      title: "Revenu et historique des paiements",
      column: {
        date: "Date",
        user: "Filleul",
        pool: "Pool",
        incomePercent: "Profit",
        income: "Montant",
      },
    },
    referrals: {
      title: "Mes filleuls",
      column: {
        user: "Filleul",
        pool: "Pool",
        deposit: "Investi",
        profit: "Profit du filleul",
        earning: "Mon revenu",
      },
    },
  },
  quest: {
    title: "Tâches et réussites",
    subtitle: "Accomplissez des tâches pour gagner des bonus et des récompenses !",
    subscribe: "Abonnez‑vous à notre Instagram !",
    follow: "Suivez‑nous sur X !",
    join: "Rejoignez notre Telegram !",
    done: "Fait",
    complete: "Terminer"
  },
  account: {
    title: "Compte",
    fields: {
      name: "Nom",
      nickname: "Surnom",
      email: "Email",
      bio: "Bio"
    },
    verify: "Vérifier",
    confirmChanges: "Confirmer les changements",
    updateSuccess: "Modifications enregistrées avec succès",
    updateError: "Échec de l'enregistrement des modifications",
    linksTitle: "Liez vos comptes pour des fonctionnalités supplémentaires",
    connectX: "Connecter X",
    connectTelegram: "Connecter Telegram",
    connectInstagram: "Connecter Instagram",
    logout: "Se déconnecter",
    emailDialog: {
      title: "Vérifiez votre e‑mail",
      description1: "Nous avons envoyé un code à 6 chiffres à {email}",
      description2: "Entrez‑le ci‑dessous pour terminer votre inscription et accéder à toutes les fonctionnalités de Zenex Hub.",
      confirmBtn: "Confirmer l’e‑mail",
      cantFind: "Vous ne trouvez pas l’e‑mail ? Vérifiez votre dossier Spam",
      resend: "ou demandez‑en un nouveau",
      sentPrefix: "Nous avons envoyé un code à 6 chiffres à"
    },
    cancel: "Annuler",
    saveChanges: "Enregistrer les modifications",
    selectNewAvatar: "Sélectionner un nouvel avatar",
    unsavedChanges: {
      title: "Modifications non enregistrées",
      subtitle: "Vous avez des modifications non enregistrées. Les annuler et quitter ?"
    }
  },
  sell: {
    to: "Retirer vers",
    select: "Sélectionner le jeton",
    button: "Retirer",
    loading: "Retrait…"
  },
  errors: {
    insufficientFunds: "Fonds insuffisants",
    maxLimit: "La limite maximale est {value}$",
    serviceUnavailable: "Service indisponible, veuillez réessayer plus tard",
  },
  card: {
    title: {
      white: "— La nouvelle ère des paiements par carte commence ici !",
      green: "par Zenex",
      yellow: "NS.Cards"
    },
    description:
      "Zéro frais de transaction, restrictions MCC, limites de dépenses jusqu’à 100 000 $ — tout cela et plus encore avec la carte Zenex.",
    button: "Obtenir votre carte",
    columns: {
      left: {
        title: {
          white: "NS.CARDS pour\n",
          green: "Mediabuyers"
        },
        items: [
          "Rechargement en crypto ou en fiat dès 2,5%",
          "Sans KYC",
          "0% de frais de transaction sur les MCC liés à la pub"
        ],
        cta: "Obtenir la carte"
      },
      right: {
        title: {
          white: "NS.CARDS",
          yellow: "Carte Wild sans limites"
        },
        items: [
          "Rechargement en crypto ou en fiat dès 2,5%",
          "Aucune limite MCC",
          "Apple Pay/Google Pay + options plastiques",
          "100k$/mois pour vos transactions"
        ],
        cta: "Obtenir la carte"
      }
    }
  },
  investHome: {
    title: "Pools RevShare",
    description:
      "Le premier RWA iGaming — Financez le trafic du casino et gagnez un % du GGR de la plateforme en rejoignant les pools ZNX RevShare pour des gains prudents ou élevés.",
    button: "Zenex Invest"
  },
  invest: {
    title: "Pools de trafic",
    description:
      "Participation au NGR du trafic de White Rabbit Casino (Kazakhstan) - whiterabbit.casino \n" +
      "Nous achetons du trafic de haute qualité, le convertissons en dépôts et partageons le profit.",
    button: "Suivre les mises à jour",
    dashboardTitle: "Tableau d'investissement",
    secondPageDescription1: "Gagnez une part du GGR des plateformes de casino.",
    secondPageDescription2: "Nous achetons du trafic de haute qualité, le convertissons en dépôts et partageons le profit.",
    dashboardDescription: "Gérez vos investissements et suivez la performance de tous les pools.",
    investFirstRowElements: [
      "années d’expérience", "Reg2Dep", "ROI mensuel", "à partir de GGR = NGR"
    ],
    poolsTitle: "Pools disponibles",
    pools: ["membres", "types de pools", "mois", "ZNX\n" + "limite totale"],
    poolsOffers: {
      titlesStable: ["Garantie de retour de capital à 100%", "34-42,5% du GGR", "Paiements en USDC"],
      titlesGrowth: ["Potentiel maximum avec ZNX", "8,5-12,75% du GGR", "Paiements en USDC"],
      whyHint: {
        safeTitle: "Pourquoi un pourcentage de GGR plus élevé ?",
        safeText: "Nous rachetons vos ZNX à leur valeur USD actuelle. Pourcentage plus élevé car nous achetons vos tokens et partageons le maximum de profits.\nLe retour garanti de votre investissement en équivalent USD protège vos fonds.",
        growthTitle: "Pourquoi un pourcentage de GGR plus bas ?",
        growthText: "Pendant 12 mois, nous gérons vos tokens ZNX, en veillant à ce que vous récupériez l'intégralité de votre investissement à la fin de la période.\nPourcentage plus bas car vous conservez la propriété et le potentiel de croissance du token"
      },
      amountStaked: "Montant staké"
    },
    poolsOffersRow: {
      payoutsStable: ["34% du GGR", "38,25% du GGR", "42,5% du GGR"],
      payoutsGrowth: ["8,5% du GGR", "10,625% du GGR", "12,75% du GGR"]
    },
    poolButton: "Entrer dans le pool",
    nrgComeFrom: {
      title: "D’où vient le NGR pour les paiements ?",
      nrgElements: {
        titles: ["GGR des joueurs", "Moins 15%", "= NGR", "Aux participants du pool"],
        subTitles: ["Gross Gaming Revenue", "Frais administratifs du casino\n" + "(15%)", "Net Gaming Revenue", "Selon le niveau\n" + "et le type de pool"]
      },
      description: "Exemple : GGR 100k$ → NGR 85k$ → Les participants reçoivent entre 8,5k$ et 42,5k$, selon le pool et le niveau."
    },
    howItWorks: {
      title: "Comment ça marche ?",
      elements: {
        titles: ["Mise en commun de jetons ZNX", "Acquisition de trafic", "Génération de profit", "Paiements mensuels", "Retour de l’investissement initial"],
        descriptions: [
          "Les participants déposent des jetons ZNX\n" + "jusqu’à une limite de 230k tokens/mois",
          "Nous achetons du trafic de haute qualité via un modèle CPA\n" + "pour White Rabbit Casino",
          "Le casino génère du GGR\n= pertes des joueurs – gains des joueurs",
          "Les participants reçoivent un % du GGR\nen USDC selon le niveau et le type de pool chaque mois",
          "Les jetons que vous avez placés dans le pool\nseront entièrement rendus après 12 mois"
        ]
      }
    },
    faq: {
      title: "Questions fréquentes",
      questions: [
        "Qu’est-ce que les Zenex RevShare Pools ?",
        "Comment les paiements sont-ils effectués ?",
        "Comment mon paiement mensuel est-il calculé ?",
        "Puis-je quitter un pool avant la fin ?",
        "Que se passe-t-il si le pool n’atteint pas le montant cible ?",
        "Quand mes ZNX seront-ils restitués ?",
      ],
      answers: [
        "Les Zenex RevShare Pools sont une tokenisation RWA d’un véritable business de casino. Vous achetez des tokens ZNX, les placez dans des pools d’acquisition de trafic pour <span>whiterabbit.casino</span> et recevez un pourcentage fixe du Gross Gaming Revenue (GGR) chaque mois pendant 12 mois.",
        "Les paiements sont effectués mensuellement en USDC le 15 de chaque mois pendant 12 mois. Les fonds sont crédités sur votre solde ZNX Hub et peuvent être retirés immédiatement ou réinvestis.",
        "Votre paiement dépend de deux éléments : votre part dans le pool et la performance mensuelle du GGR du casino.",
        "Non, une sortie anticipée est impossible. Les fonds sont verrouillés dans un smart contract pendant 12 mois. Cela nous permet de planifier les campagnes marketing et de garantir des rendements stables.",
        "Le pool sera lancé quoi qu’il arrive. Les proportions de distribution des bénéfices seront déterminées après l’achat mensuel de trafic.",
        "100 % des tokens ZNX que vous avez placés dans le pool seront automatiquement restitués après 12 mois.",
      ]
    },
    betshops: {
      title: "Betshops"
    },
    questions: {
      title: "Vous avez encore des questions ?",
      subtitle: "Contactez notre équipe dès maintenant pour trouver le meilleur pool pour vos objectifs !",
      button: "Nous contacter"
    },
    moreInfo: {
      title: "Plus d’informations sur les pools Zenex RevShare",
      telegram: "Notre Telegram",
      instagram: "Notre Instagram",
      linkedin: "Notre LinkedIn"
    },
    payoutVariations: {
      title: "Comment les paiements peuvent varier",
      inputLabel: "Entrez le montant de l’investissement",
      weakLabel: "Scénario faible",
      strongLabel: "Scénario fort",
      months: [
        "Aujourd’hui",
        "Jan 2025",
        "Avr 2025",
        "Juil 2025",
        "Oct 2025",
        "Jan 2026",
        "Avr 2026",
        "Juil 2026",
        "Oct 2026",
        "Déc 2026"
      ],
      weakScenarioLabel: "Rendement total en scénario faible (aucune hausse de prix)",
      strongScenarioLabel: "Rendement total en scénario fort (hausse de prix de 150%)",
      disclaimer: "Les calculs sont basés sur les performances historiques et ne constituent pas des prévisions."
    },
    header: {
      smallTitle: "Zenex RevShare Pools",
      mainHeading: "Profitez des revenus des casinos sans les coûts ni les risques opérationnels",
      description: "Nous achetons du trafic de haute qualité pour les casinos, le convertissons en dépôts et partageons les profits",
      ctaStartEarning: "Commencer à gagner",
      ctaViewStatistics: "Voir les statistiques",
      stats: {
        item1: {
          value: "60 mois",
          description: {
            prefix: "Rentabilité prouvée de",
            link: "White Rabbit Casino"
          }
        },
        item2: {
          value: "40%+",
          description: "Conversion inscription→dépôt leader du secteur"
        },
        item3: {
          value: "Transparent",
          description: "Rapports de performance et données mensuelles"
        },
        item4: {
          value: "Deux sources de revenus",
          description: "Paiements mensuels en USDC et restitution intégrale de vos ZNX avec potentiel de hausse"
        }
      }
    },
    enterToPoolDialog: {
      title: "Montant total ZNX",
      availableBalance: "Solde disponible",
      stakedInPool: "Staké dans ce pool",
      buttonTopUp: "Recharger le solde",
      buttonEnterPool: "Entrer dans le pool",
      choosePlan: "Choisissez votre plan",
      inputLabel: "Entrez le montant de ZNX",
      inputMessages: {
        exceedsBalance: "Dépasse le solde",
        increase: {
          toIncrease: "Pour augmenter votre",
          addAdditional: "ajoutez",
          stable: {
            toBasic: "GGR à 34%",
            toAdvanced: "GGR à 38,25%",
            toPremium: "GGR à 42,5%"
          },
          growth: {
            toBasic: "GGR à 8,5%",
            toAdvanced: "GGR à 10,625%",
            toPremium: "GGR à 12,75%"
          }
        }
      }
    },
    myActivePools: {
      title: "Mes pools actifs",
      myActivePoolElements: ["Staké", "Plan\n" + "actuel", "GGR"],
      myActivePoolElementsV2: ["Taille du pool", "Staké", "Plan actuel", "GGR", "Total gagné"],
      growUp: "Améliorez votre plan pour augmenter vos gains !",
      missing: "Manquant",
      buttonStats: "Voir les stats",
      buttonAddZNX: "Ajouter ZNX",
      buttonClaim: "Réclamer",
      months: {
        january: "Janvier",
        february: "Février",
        march: "Mars",
        april: "Avril",
        may: "Mai",
        june: "Juin",
        july: "Juillet",
        august: "Août",
        september: "Septembre",
        october: "Octobre",
        november: "Novembre",
        december: "Décembre"
      },
      status: {
        active: "Actif jusqu’au {date}",
        prefunding: "Préfinancement",
        closed: "Fermé",
      },
      upgrade: {
        label: "Améliorez votre plan vers",
        boost: "Augmentez les gains à {percent}% du GGR ({ggr})",
        missing: "Manquant : ",
      },
    },
    stats: {
      title: "Tableau de bord White Rabbit Analytics",
      description: "Analyse opérationnelle",
      claimButton: "Réclamer",
      chartPerios: ["1j", "1s", "1m"],
      chartLine: "Dynamique du GGR",
      barLine: "Dynamique des joueurs actifs",
      addZnx: "Ajouter ZNX",
      spent: "Dépensé",
      ftdLabel: "FTD\n(Déposants pour la première fois)",
      cpaLabel: "CPA\n(Coût par FTD)",
      averageDeposit: "Dépôt moyen",
      ggrThisMonth: "GGR ce mois-ci",
      totalGgr: "GGR total",
      day: "Jour {day}",
      activity: {
        title: "Statut d’activité du pool",
        status: {
          active: "Actif jusqu’au {date}",
          prefunding: "Préfinancement",
          closed: "Fermé",
          traffic: "Acquisition de trafic"
        },
      },
      prefunding: {
        goal: "Objectif de levée",
        raised: "Collecté",
        investors: "Investisseurs",
        launch: "Lancement dans"
      },
      stake: {
        label: "Ma participation",
        elements: ["En staking", "Plan actuel", "GGR", "Prochain paiement", "Total gagné"],
      },
      upgrade: {
        label: "Améliorez votre plan vers",
        boost: "Augmentez les gains à {percent}% du GGR ({ggr})",
        missing: "Manquant : ",
      },
      placeholderPool: {
        title: "Les statistiques seront disponibles après le lancement du pool",
        description: "Investissez maintenant pour accéder en avant-première aux données de performance !",
        action: "Rejoindre le pool",
      },
      myPayouts: {
        title: "Mes paiements",
        action: "Réclamer",
        pool: "Paiement {pool} de {month}",
        stable: "Stable Pool",
        growth: "Growth Pool",
        eta: {
          days: "{count, plural, one {# jour} other {# jours}}",
          hours: "{count, plural, one {# heure} other {# heures}}",
        },
      },
      months: {
        january: "Janvier",
        february: "Février",
        march: "Mars",
        april: "Avril",
        may: "Mai",
        june: "Juin",
        july: "Juillet",
        august: "Août",
        september: "Septembre",
        october: "Octobre",
        november: "Novembre",
        december: "Décembre"
      },
      yourPayouts: "Vos"
    },
    transparency: {
      title: "Transparence",
      lastUpdated: "Dernière mise à jour :",
      dataSource: "Source des données :",
      crossGamingRevenue: "Gross Gaming Revenue",
      adminFee: "Frais Admin (15%)",
      netGamingRevenue: "Net Gaming Revenue",
      totalDeposits: "Dépôts totaux",
      playersCount: "Nombre de joueurs"
    },
    overview: {
      title: "Aperçu personnel des investissements",
      totalInvested: "Total investi",
      totalEarned: "Total gagné",
      nextPayout: "Prochain paiement",
      poolShare: "Votre part du pool :",
      roi: "ROI :",
      paymentDate: "Date de paiement :",
      poolMetrics: "Métriques du pool",
      poolSize: "Taille du pool",
      investors: "Investisseurs",
      staked: "Staké",
      players: "Joueurs"
    },
    totalStaked: {
      title: "Total staké dans les pools",
      button: "Investir dans les pools",
      stable: "stable pool",
      growth: "growth pool",
      totalFormat: "{total}/{max} ZNX"
    },
    whiteRabbitPromo: {
      title: "Stats du pool White Rabbit",
      subtitle: "Voyez les chiffres, calculez vos gains, rejoignez maintenant",
      button: "Ouvrir les statistiques"
    },
    poolMetrics: {
      title: "Métriques du pool",
      metricsElements: ["Taille du pool", "Investisseurs", "Staké", "Joueurs"]
    },
    growthDetails: {
      title: "Zenex Growth Pool",
      progress: {
        label: "Progression du pool"
      },
      metrics: {
        ggrShareLabel: "Part du GGR du casino",
        lockPeriodLabel: "Période de blocage",
        lockPeriodValue: "12 mois",
        payoutsUSDCLabel: "Paiements en USDC",
        payoutsFrequencyValueMonthly: "Mensuel",
        returnedAfterLabel: "Restitué après 12 mois",
        returnedAfterValue: "100% ZNX"
      },
      tooltips: {
        tierShare: "Votre part du casino dépend du niveau",
        payoutsDepend: "Les paiements dépendent du GGR mensuel du casino",
        noEarlyWithdrawal: "Pas de retrait anticipé",
        znxGrowth: "Si le ZNX augmente, votre rendement final augmente aussi"
      },
      tier: {
        depositLabel: "Dépôt :",
        note: "Le niveau est déterminé automatiquement par le montant du dépôt"
      },
      button: {
        closed: "Levée de fonds close"
      }
    },
    joinPool: "Rejoindre le pool",
    poolsPromoTitle: "Les statistiques apparaîtront après le lancement du pool",
    poolsPromoSubtitle: "Investissez maintenant pour accéder en premier aux données de performance !"
  },
  buy: {
    currency: "Devise",
    network: "Réseau",
    sum: "Montant",
    min: "Minimum",
    max: "Maximum",
    loading: "Chargement…",
    buy: "Acheter",
    approve: "Transférer {amount} {currency} à l’adresse :"
  },
  claim: {
    have: "Vous avez",
    available: "jetons disponibles",
    description:
      "Cliquez sur le bouton « Réclamer » pour les ajouter au solde de votre compte.",
    button: "Réclamer",
    check: "Vérifier",
    total: "Votre score total",
    tooltip: "Champ facultatif",
    notice: {
      white: "Entrez le code bonus pour obtenir",
      green: "x2 jetons ZNX."
    },
    errors: {
      invalidCode: "Code invalide",
      codeExpired: "Le code a expiré.",
      codeRequired: "Le code est obligatoire."
    },
    optional: "Champ facultatif"
  },
  page: {
    title: {
      green: "Bienvenue sur",
      yellow: "Zenex Hub !"
    },
    descriptions1:
      "Merci de croire en nous et de vouloir grandir avec nous !",
    descriptions2:
      "Nous sommes dans la phase finale de test et dévoilerons bientôt toutes nos fonctionnalités.",
    descriptions3: "Jouez maintenant pour réclamer vos",
    descriptions4: "jetons gratuits",
    descriptions5: "— ne manquez pas !",
    buttons: {
      play: "Jouer à la chasse au trésor",
      get: "Obtenir ZNX"
    },
    notice: "Cette offre est disponible pour une durée limitée seulement.",
    back: "Retour",
    tabs: {
      account: "Compte",
      safety: "Sécurité",
      notifications: "Notifications",
      referrals: "Parrainages",
      quests: "Quêtes"
    }
  },
  balance: {
    title: "Vos collections NFT"
  },
  header: {
    title: {
      profile: "Paramètres du profil",
      reshare:"Investissements"
    },
    welcome: "Bienvenue {username} !",
    welcome_empty: "Bienvenue !",
    button: {
      logout: "Déconnexion"
    },
    labels: {
      address: "Adresse :",
      caipAddress: "Adresse CAIP :",
      status: "Statut :"
    },
    dropdown: {
      supportChat: "Chat de support",
      documents: "Documents",
      legalDocuments: "Documents juridiques",
      termsOfUse: "Conditions d'utilisation",
      privacyPolicy: "Politique de confidentialité",
      cookiesPolicy: "Politique relative aux cookies",
      buyZNXwithCrypto: "ZNX avec des crypto-monnaies",
      buyZNXonDEX: "ZNX sur DEX",
      buyZNXwithCard: "ZNX avec une carte"
    }
  },
  login: {
    title: {
      green: "Bienvenue sur",
      white: "Zenex Hub !"
    },
    button: "Se connecter"
  },
  plans: {
    title: "Programmes d’accès à l’investissement Zenex",
    welcome: "Bienvenue {username} !",
    welcome_empty: "Bienvenue !",
    cards: {
      silver: {
        title: "Niveau Argent",
        subtitle: "Investisseur précoce",
        items: [
          "1 000 places",
          "ZNX Play : Staking ×1,5 (6 mois)",
          "ZNX Arena : 5 cartes standard + 1 or",
          "ZNX Invest : Accès exclusif aux pools",
          "Bonus : 850 ZNX"
        ]
      },
      gold: {
        title: "Niveau Or",
        subtitle: "Partenaire stratégique",
        items: [
          "200 places",
          "ZNX Play : Staking ×2 (12 mois)",
          "ZNX Arena : 8 cartes standard + 2 or",
          "ZNX Invest : +10% de rendement du pool",
          "Bonus : 4 200 ZNX"
        ]
      },
      platinum: {
        title: "Niveau Platine",
        subtitle: "Investisseur VIP",
        items: [
          "50 places",
          "ZNX Play : Staking ×3 (12 mois)",
          "ZNX Arena : 10 cartes standard + 3 or",
          "ZNX Invest : +20% de rendement du pool",
          "Chat privé",
          "Bonus : 12 500 ZNX"
        ]
      },
      diamond: {
        title: "Niveau Diamant",
        subtitle: "Partenaire fondateur",
        items: [
          "20 places",
          "ZNX Play : Staking ×4 (12 mois)",
          "ZNX Arena : 10 cartes standard + 5 or",
          "ZNX Invest : +30% de rendement + allocations garanties",
          "Chat privé + influence sur la plateforme",
          "Mention au Hall of Fame",
          "Bonus : 12 500 ZNX"
        ]
      }
    },
    button: "Acheter",
    available: "Positions disponibles",
    benefits: "Avantages"
  },
  opportunities: {
    cards: {
      play: {
        title: "ZNX Play",
        description: "Conservez ZNX, gagnez des récompenses — aucun effort."
      },
      invest: {
        title: "ZNX Invest",
        description:
          "Gagnez avec le premier RWA iGaming avec seulement 50 ZNX"
      },
      cases: {
        title: "Coffres et boîtes",
        description: "Ouvrez des coffres pour des récompenses, boosters ou avantages aléatoires."
      },
      arena: {
        title: "ZNX Arena",
        description:
          "Profitez des promoteurs qui se disputent des clients dans un show business."
      }
    },
    button: "Bientôt",
    buttonOpen: "Ouvrir"
  },
  meta: {
    title: "Français"
  },
  cards: {
    transactions: {
      title: 'Dernières transactions',
      column: {
        card: "Carte",
        date: "Date",
        details: "Détails",
        status: "Statut",
        amount: "Montant",
        fee: "Frais"
      },
      status: {
        RESERVED: "Réservé",
        UNRESERVED: "Non réservé",
        TRANSFERRED: "Transféré",
        REFUNDED: "Remboursé",
        REFUNDED_PARTIAL: "Remboursement partiel",
        FAILED: "Échoué",
        LOADED: "Chargé",
        UNLOADED: "Déchargé",
        COMPLETED: "Complété"
      }
    },
    myCards: {
      title: "Mes cartes",
      goToSite: "Aller sur NS.Cards",
      balance: 'Solde',
      buyNewCards: "Acheter une nouvelle carte",
      cardRedirect: "Vous serez redirigé vers un service externe pour finaliser votre achat",
      topUpZnx: "Recharger avec ZNX",
      confirmTopUp: "Confirmer la recharge",
      topUpAmount: 'Montant de la recharge',
      viewAllCards: 'Voir toutes les cartes',
      hideCards: 'Masquer les cartes',
      loading: 'Chargement',
      loadingAddress: "Chargement de l'adresse de dépôt...",
    }
  },
  wallet: {
    title: {
      main: "Portefeuille",
      mainNew: "Portefeuille non-custodial",
      balance: "Actifs totaux",
      cards: "Zenex Cards",
      transaction: "Historique des transactions",
      calendar: "Calendrier des paiements",
      payments: "Paiements à venir"
    },
    availableBalance: "Solde disponible",
    chooseAssets: "Choisissez un actif",
    walletNetworkDeposit: "Réseau de dépôt",
    walletNetworkWithdraw: "Réseau de retrait",
    address: "Adresse",
    destinationAddress: "Adresse de destination",
    enterAddress: "Entrer l’adresse",
    pasteWalletAddress: "Coller l’adresse du portefeuille",
    enterAmount: "Entrez le montant",
    withdrawAmount: "Montant du retrait",
    minimumWithdrawAmount: "Montant minimum du retrait : {value}",
    transactionDetails: "Détails de la transaction",
    transactionFee: "Frais de transaction",
    insufficientFundsForFee: "Fonds insuffisants pour couvrir les frais de transaction.",
    missing: "Manquant : {value}",
    addSol: "Ajouter SOL",
    paste: "Coller",
    max: "Max",
    doubleCheckWithdraw: "Veuillez vérifier l’adresse de retrait !",
    doubleCheckDeposit: "Veuillez vérifier l’adresse de dépôt !",
    sendingFundsToWrong: "Envoyer des fonds à une mauvaise adresse peut entraîner la perte irrémédiable\n" + "de votre cryptomonnaie.",
    theProcedureUpTo48Hours: "La procédure peut prendre de 1 à 2 minutes !",
    theProcedureUpTo30min: "La procédure peut prendre jusqu'à 30 minutes",
    exRate: "Taux de change",
    swap: "Confirmer",
    sell: "Vendre",
    receive: "Recevoir",
    send: "Envoyer",
    mainTitle: "Échange",
    amount: "Montant",
    toSwap: "Échanger",
    searchTokens: "Rechercher un jeton",
    selectCurrency: "Sélectionner une devise",
    selectCurrencyOrNetwork: "Sélectionner une devise ou un réseau",
    selectToken: "Sélectionner le jeton",
    selectNetwork: "Sélectionner le réseau",
    continueInWallet: "Continuer dans le portefeuille",
    swapReview: "Veuillez vérifier les détails de la transaction\n" + "avant la confirmation !",
    depositAddress: "Adresse de dépôt",
    walletDepositLoading: "Veuillez patienter, votre adresse de dépôt est en cours de génération…",
    walletSwapDepositLoading: "Veuillez patienter pendant l’initialisation de votre opération d’échange…",
    swapPage: {
      youSend: "Vous envoyez",
      youReceive: "Vous recevez",
      swapMinDeposit: "Dépôt minimum",
      fee: "Frais",
      feeWithdraw: "Frais de retrait",
      finish: "Terminer",
      swapSuccess: "Échange effectué avec succès",
      swapError: "Échec de l'échange. Veuillez réessayer."
    },
    balanceButtons: {
      deposit: "Dépôt",
      withdraw: "Retrait",
      exchange: "Échange",
      buyZNX: "Acheter ZNX"
    },
    transactionHistory: {
      type: "Type",
      total: "Total",
      info: "Infos",
      date: "Date",
      status: "Statut"
    }

  },
  paymentProcess: {
    awaitingPayment: "En attente de paiement",
    confirmed: "Confirmé",
    swapped: "Échangé",
    swapping: "Échange en cours",
    sending: "Envoi de ZNX",
    sendingToken: "Envoi de {token}",
    usualTime: "Cela prend généralement 5–30 minutes."
  },
  transactionStatus: {
    complete: "Transaction terminée !",
    failed: "Échec de la transaction",
    withdrawFailed: "Échec du retrait",
    successSend: "{token} a été envoyé avec succès vers votre portefeuille.",
    errorOccurred: "Une erreur s’est produite lors du traitement de la transaction.",
    viewOnExplorer: "Voir sur l’explorateur",
    contactSupport: "Contacter le support",
    backToWallet: "Retour au portefeuille",
    withdrawComplete: "Retrait terminé !",
    withdrawAmountLabel: "Montant du retrait",
    destinationAddressLabel: "Adresse de destination",
    estimatedProcessingTimeLabel: "Temps de traitement estimé",
    transactionFeeLabel: "Frais de transaction",
    continueInWallet: "Continuer dans le portefeuille",
    checkOnSolscan: "Vérifier sur Solscan",
    withdrawEtaValue: "{value} minutes",
    withdrawEtaDefault: "1-2 minutes",
    swapComplete: "Échange terminé !",
    swapFailed: "Échange échoué",
    youSendLabel: "Vous envoyez",
    exchangeRateLabel: "Taux de change",
    youGetLabel: "Vous recevez"
  },
  play: {
    banner: {
      title: "Staking & Loterie",
      description: "Stakez vos tokens $ZNX pour gagner des récompenses. Plus vous stakez longtemps, plus vos chances de gagner augmentent !"
    },
    statsSmall: {
      previousJackpot: "Jackpot précédent",
      upcomingPayment: "Paiement à venir",
      activeParticipants: "Participants actifs"
    },
    ctaStake: "Staker et gagner",
    chipActive: "Actif",
    stats: {
      totalValueStaked: "Valeur totale stakée",
      activeStakers: "Stakers actifs",
      currentPrizePool: "Cagnotte actuelle"
    },
    nextDraws: {
      title: "Prochains tirages",
      description: "Compte à rebours jusqu’à la prochaine loterie. Ne manquez pas votre chance !"
    },
    jackpots: {
      weekly: "JACKPOT HEBDOMADAIRE",
      monthly: "JACKPOT MENSUEL",
      annual: "JACKPOT ANNUEL"
    },
    time: {
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes"
    },
    prizeSub: "dans la cagnotte",
    stakeDialog: {
      header: "Démarrer le staking",
      description: "Choisissez le montant et la durée pour un potentiel de profit maximal",
      labelAmount: "Montant à staker (ZNX)",
      placeholderAmount: "Entrez le montant",
      max: "MAX",
      infoMessage: "Augmentez la mise à 500 ZNX pour doubler votre profit potentiel !",
      plan: {
        multiplier: "Multiplicateur",
        labelApy: "APY fixe"
      },
      stats: {
        weeklyDistribution: "Distribution hebdomadaire",
        monthlyDistribution: "Distribution mensuelle",
        totalPotentialProfit: "Profit potentiel total"
      },
      createStake: "Créer un stake"
    },
    summaryRow: {
      stakeAmount: "Montant staké",
      duration: "Durée",
      fixedApy: "APY fixe",
      guaranteedProfit: "Profit garanti",
      additionalProfitChance: "Chance de profit supplémentaire"
    }
  },
  connectDialog: {
    text: "Connectez votre portefeuille pour voir tous les produits disponibles !",
    button: "Connecter le portefeuille"
  },
  profileCard: {
    hiUser: "Salut, utilisateur",
    copyFullAddress: "Copier l’adresse complète",
    profileSettings: "Paramètres du profil"
  },
  welcomeDashboard: {
    subTitle: "Engager. Gagner. Autonomiser.",
    description: "Le premier écosystème iGaming‑Fintech avec Casino RWA et des solutions révolutionnaires !",
    button: "Connecter le portefeuille",
    revsharePools: {
      titleAccent: "Revshare",
      titleRest: "pools",
      description1: "Le premier RWA iGaming — Financez le trafic casino en CPA et gagnez un % des revenus de la plateforme (GGR)",
      description2: "en rejoignant les pools RevShare ZNX pour des gains conservateurs ou à haut rendement.",
      cta: "Commencer à gagner"
    },
    dashboardElements: {
      invest: {
        text: "Gagnez chaque mois grâce aux produits Casino RWA leaders du secteur",
        button: "Gagner des ZNX et des USDC"
      },
      play: {
        text: "Conservez des ZNX, gagnez un revenu passif,\net multipliez‑le dans nos mini‑jeux.",
        button: ""
      },
      arena: {
        text: "Profitez des promoteurs en compétition pour des clients dans le premier reality show business du casino.",
        button: ""
      }
    },
    dashboardReferral: {
      boost: "Boostez vos gains avec",
      programName: "Programme de Parrainage"
    },
    dashboardConnect: {
      subTitle: "S'engager. Gagner. S'émanciper.",
      text: "Le premier écosystème iGaming-Fintech\navec Casino RWA et des solutions révolutionnaires !"
    },
    dashboardPartners: {
      title1: "Réseau mondial.",
      title2: "Vision partagée.",
      subTitle: "Intégré avec des partenaires iGaming et fintech de premier plan, nous exploitons les technologies blockchain et de contrats intelligents\n pour développer des solutions de nouvelle génération."
    },
    dashboardPhotos: {
      title: "Moments",
      subtitle: "Personnes. Énergie. Innovation.",
      followUs: "Suivez-nous pour plus de moments",
      texts: {
        We_brought: "Nous avons apporté l'esprit Web3 au MAC Erevan",
        Innovation_networking: "Innovation, réseautage et idées audacieuses — c'est CPA Life Fest avec Zenex",
        Zenex_at: "Zenex à BroConf — pure énergie",
        Connecting_minds: "Relier les esprits à TOKEN2049",
        Game_on: "C’est parti au SBC Summit",
        From_insights: "Des idées à l’action — au CPA Life Fest",
        TOKEN2049_vibes: "Ambiance TOKEN2049 : vraies discussions, croissance, énergie",
        Behind_every: "Derrière chaque événement, il y a une histoire — d’idées audacieuses, de partenariats et d’expériences inoubliables qui font avancer la communauté Zenex.",
        Bright_ideas: "Idées lumineuses, SiGMA"
      }
    }

  }
};